export const PERCENTAGEANDAMOUNT = 'percentage_and_amount';
export const PERCENTAGE = 'percentage';


// WEBPACK FOOTER //
// ./src/components/Rules/constants.js